






























































































































































































































































































































































































































import { Component, Vue } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import ConfigIntegracaoOperadoraStore from '@/components/Configuracoes/store/ConfigIntegracaoOperadoraStore'
import EventBus from '@/plugins/EventBus'
import { onlyNumber } from '@/utils/common'
import { useHospitais } from '@/composables'

@Component

export default class ViewConfiguracaoIntegracaoOperadora extends Vue {
  modalOperadoras: boolean = false
  modalOperadora: boolean = false
  modalProcedimento: boolean = false
  loadingHospital: boolean = false
  loadingSalvarBtn: boolean = false
  loadingAtualizar: boolean = false
  loadingProcedimento: boolean = false
  loadingSaveOrUpdateProcedimento: boolean = false

  $refs!: {
    formHospitalConfiguracaoOperadora: any,
    formOperadora: any,
    formProcedimento: any,
  }

  loading: any = {
    listText: 'Operadora não encontrado.',
  }

  get hospitais() {
    return useHospitais.hospitaisByCurrentUser
  }

  fetchHospitais() {
    return useHospitais.loadHospitaisByCurrentUser()
  }

  get getConfigIntegracaoOperadoraStore() {
    return getModule(ConfigIntegracaoOperadoraStore, this.$store)
  }

  get getHospitalId() {
    return this.getConfigIntegracaoOperadoraStore.hospitalId
  }

  set getHospitalId(value: any) {
    this.getConfigIntegracaoOperadoraStore.setHospital(value)
  }

  get getOperadoras() {
    return this.getConfigIntegracaoOperadoraStore.operadoras
  }

  get getProcedimentos() {
    return this.getConfigIntegracaoOperadoraStore.operadora.procedimentos
  }

  get getHeaders() {
    return [
      { text: 'Código', value: 'codigo', sortable: false },
      { text: 'Descrição', value: 'descricao', sortable: false },
      { text: 'Status', value: 'status', sortable: false },
      { text: 'Tipo', value: 'tipo', sortable: false },
      { text: 'Ações', value: '', align: 'center', sortable: false },
    ]
  }

  onlyNumberUtil(value) {
    return onlyNumber(value)
  }

  addProcedimento(mode: string) {
    this.getConfigIntegracaoOperadoraStore.setMode(mode)
    this.modalProcedimento = true
  }

  editProcedimento(item: any) {
    this.getConfigIntegracaoOperadoraStore.setMode('EDIT')
    this.getConfigIntegracaoOperadoraStore.setProcedimento({ ...item })
    this.$refs.formProcedimento.resetValidation()
    this.modalProcedimento = true
  }

  async saveOrUpdateProcedimento() {
    this.loadingSaveOrUpdateProcedimento = true

    if (!this.$refs.formProcedimento.validate()) {
      this.loadingSaveOrUpdateProcedimento = false
      return
    }

    if (this.getConfigIntegracaoOperadoraStore.mode === 'CREATE') {
      this.getConfigIntegracaoOperadoraStore.setNovoProcedimento({ ...this.getConfigIntegracaoOperadoraStore.procedimento })
    } else {
      this.getConfigIntegracaoOperadoraStore.setEditProcedimento({ ...this.getConfigIntegracaoOperadoraStore.procedimento })
    }

    this.closeModalProcedimento()
    this.loadingSaveOrUpdateProcedimento = false
  }

  async closeModalProcedimento() {
    this.$refs.formProcedimento.reset()
    this.modalProcedimento = false
  }

  async enviarOperadora() {
    if (!this.$refs.formOperadora.validate()) return
    this.loadingAtualizar = true
    const response = await this.getConfigIntegracaoOperadoraStore.enviarOperadora()
    if (response.success) {
      EventBus.$emit('setSnackbar', {
        show: true,
        text: `Configuracao enviado com sucesso! ${String.fromCodePoint(0x1F642)}`,
        icon: 'done',
        color: '#2E7D32',
      })
      this.closeModalOperadora()
    } else {
      EventBus.$emit('setSnackbar', {
        show: true,
        text: response.message ? `${response.message} ${String.fromCodePoint(0x1F615)}` : `Ocorreu um erro ao enviar a configuração ${String.fromCodePoint(0x1F615)}`,
        icon: 'warning',
        color: '#C62828',
      })
    }
    this.loadingAtualizar = false
  }

  async closeModalOperadora() {
    this.modalOperadora = false
    this.getConfigIntegracaoOperadoraStore.clearOperadora()
    this.$refs.formOperadora.reset()
  }

  async addSelected(item) {
    EventBus.$emit('setLoadingRequest', { status: true, text: 'Carregando...' })
    const response = await this.getConfigIntegracaoOperadoraStore.getOperadoraById(item.id)
    EventBus.$emit('clearLoadingRequest')

    this.modalOperadora = true
    if (!response.success) {
      EventBus.$emit('setSnackbar', {
        show: true,
        text: response.message ? `${response.message} ${String.fromCodePoint(0x1F615)}` : `Ocorreu um erro ao consultar a operadora ${String.fromCodePoint(0x1F615)}`,
        icon: 'warning',
        color: '#C62828',
      })
    }
  }

  async hospitalChange() {
    this.loadingHospital = true
    const response = await this.getConfigIntegracaoOperadoraStore.getHospitalConfiguracaoOperadora()
    if (!response.success) this.$refs.formHospitalConfiguracaoOperadora.reset()
    this.loadingHospital = false
  }

  async enviarConfiguracao() {
    this.loadingSalvarBtn = true
    if (!this.$refs.formHospitalConfiguracaoOperadora.validate()) return
    const response = await this.getConfigIntegracaoOperadoraStore.enviarHospitalConfiguracaoOperadora()
    if (response.success) {
      EventBus.$emit('setSnackbar', {
        show: true,
        text: `Configuracao enviado com sucesso! ${String.fromCodePoint(0x1F642)}`,
        icon: 'done',
        color: '#2E7D32',
      })
    } else {
      EventBus.$emit('setSnackbar', {
        show: true,
        text: response.message ? `${response.message} ${String.fromCodePoint(0x1F615)}` : `Ocorreu um erro ao enviar a configuração ${String.fromCodePoint(0x1F615)}`,
        icon: 'warning',
        color: '#C62828',
      })
    }
    this.loadingSalvarBtn = false
  }

  async getAllOperadora() {
    const response = await this.getConfigIntegracaoOperadoraStore.getAllOperadora()
  }
}
